import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var IconDarkMode20pxRegular = function IconDarkMode20pxRegular(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 20 20",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.228 3.393C6.091 4.033 3.75 6.758 3.75 10c0 3.714 3.074 6.75 6.896 6.75a6.956 6.956 0 004.534-1.663c-4.043-.153-7.296-3.42-7.296-7.455 0-1.577.498-3.037 1.344-4.24zM2.25 10c0-4.57 3.773-8.25 8.396-8.25.15 0 .3.004.447.011a.75.75 0 01.441 1.326 5.896 5.896 0 00-2.15 4.545c0 3.278 2.714 5.96 6.092 5.96.467 0 .923-.052 1.36-.15a.75.75 0 01.783 1.156 8.43 8.43 0 01-6.973 3.652c-4.623 0-8.396-3.68-8.396-8.25z"
    })
  }));
};
export default IconDarkMode20pxRegular;